import React, { useRef, useState, useEffect } from 'react'
import { ThemesProperties } from '../CanvasConstants/ThemesProperties'
import { CanvasHeader } from '../ActivityUIComponents/CanvasHeader'
import { TemplatesList } from '../CanvasComponents/TemplatesList'
import { HeaderModal } from '../CanvasComponents/HeaderModal'
import {
  saveCurrentPageDataInLocal,
  studentDataToApi
} from '../utils/StudentDataUtils'
import { SmartCanvasTemplates } from './SmartCanvasTemplates'
import { getSubmitDate, getTimeSpent } from '../utils/TimerUtils'
import { KnovaPalette } from '../BasicUIComponents/KnovaPalette'
import {
  CHAT_BOT,
  COLOR_PALETTE,
  FEEDBACK_BOT,
  ONETIME,
  PEN,
  PREVIOUS_WORK,
  QUESTION,
  REPLAY,
  SELECT,
  SEQUENCE_BOT,
  SKETCH_PAD,
  TEXT_AREA,
  TUTOR_BOT
} from '../constants'
import { Button } from 'carbon-components-react'
import {
  Maximize,
  Minimize,
  PreviousOutline,
  NextOutline
} from '@carbon/icons-react'
import { AiAssistanceBot } from '../UIUtilsFiles/AiAssistanceBot'
import { BotAssistSettings } from '../UIUtilsFiles/BotAssistSettings'
import { ExtraPracticeModal } from '../CanvasComponents/ExtraPracticeModal'

function SmartCanvasBaseScreen(props) {
  //variables from knova activity screen
  const {
    activityDataFromParent,
    isBgAudioPlayed,
    minutes,
    seconds,
    Completed,
    isActive,
    onToastTrigger,
    isPreview,
    isSequence,
    isClassroom
  } = props
  const {
    currentLessonUnitDistId,
    user,
    activitySaveType,
    activitySaveClick,
    updatedAIResponse,
    currentOSName,
    isActivitySideMenuOpen,
    activityResetType
  } = props
  const {
    getActivityLoaded,
    getStudentCurrentScore,
    knovoHelpClose,
    getStudentWorkedDataFromChild,
    getTutorTalking,
    getFullscreen,
    handleChatClarification,
    getRecordingStatus,
    getCurrentActivePage,
    getStrokeReplaying,
    getExtraPracticeStatus
  } = props //values to parent activity screen
  //Activity data
  const [currentActivity, setCurrentActivity] = useState({})
  const {
    ActivityJson,
    ContentID,
    InkJson,
    ActivityType,
    AppName,
    Feedback,
    FollowTheFlow,
    ContainedView,
    WorkJson,
    OtherActivities,
    Status
  } = currentActivity
  const isPractice = ActivityType === 'practice' ? true : false
  const SAVE_MODE = { SAVE: 'SAVE', SUBMIT: 'SUBMIT' }
  const [smartCanvasData, setSmartCanvasData] = useState({
    BackgroundImage: '',
    Strokes: [],
    StrokeActions: [],
    InputRows: [],
    ReplayRectangles: [],
    TotalScore: 0,
    EditorImageHeight: 0,
    EditorImageWidth: 0,
    ReplayRectanglesAudio: [],
    Opacity: 'rgba(0,0,0,0)',
    TextToSpeech: [],
    Seconds: [],
    Back: false,
    Skip: false,
    Stop: false,
    ChatBotSettings: ''
  })
  const [allPagesData, setAllPagesData] = useState([])
  const [currentPageNumber, setCurrentPageNumber] = useState(-1)
  const [overallActivityScore, setOverallActivityScore] = useState(0)
  const pageScrollType = useRef()
  const [updateInitial, setUpdateInitial] = useState(false)
  const [isPageNavigated, setIsPageNavigated] = useState(false)
  const isPageChanged = useRef(false)

  //Student data variables
  const [controlsList, setControlsList] = useState([])
  const [currentScore, setCurrentScore] = useState(0)
  const [isWorkAvailable, setIsWorkAvailable] = useState(false)
  const [studentWorkData, setStudentWorkData] = useState({})

  const [displayComponents, setDisplayComponents] = useState(false)
  //Secondary header popup variables
  const [isSecModalActive, setIsSecModalActive] = useState(false)
  const [secModalActiveName, setSecModalActiveName] = useState('')
  const [isPalleteOpen, setIsPalleteOpen] = useState(false)
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false)
  const [strokeReplayStarted, setStrokeReplayStarted] = useState(false)

  //sketchpad variables
  const [sketchPadDataArray, setSketchPadDataArray] = useState([])
  const [sketchPadInitial, setSketchPadInitial] = useState(false)
  //Text area variables
  const [textAreaData, setTextAreaData] = useState('')

  //Replay Rectangle data
  const [replayRectangleStrokesData, setReplayRectangleStrokesData] = useState({
    ControlID: 0,
    BoxPosition: 0,
    strokeArray: [],
    strokeActions: []
  })
  const [strokeWidth, setStrokeWidth] = useState(5)
  const [strokeColor, setStrokeColor] = useState('#000000')
  const [sketchType, setSketchType] = useState(PEN)
  const [currentSpeed, setcurrentSpeed] = useState(ONETIME)
  const [isReplaying, setIsReplaying] = useState(false)

  //Sequence variables
  const [priorityActive, setPriorityActive] = useState(0)
  const [skipUnskipComponent, setSkipUnskipComponent] = useState({})

  //Record audio variables
  const [savedAudioURL, setSavedAudioURL] = useState(null)

  //AI chat bot variables added by Azar
  const [isAiChatBotVisible, setIsAiChatBotVisible] = useState(false)
  const [aiChatResponseData, setAiChatResponseData] = useState({})
  const [challengeResponse, setChallengeResponse] = useState({})
  const [isKnovoApiCall, setIsKnovoApiCall] = useState(false)
  const [isNeedClick, setIsNeedClick] = useState(false)

  //Template fullscreen variables
  const [isMinimize, setIsMinimize] = useState(true)

  const [isRecording, setIsRecording] = useState(false)
  const [isVideoPlaying, setIsVideoPlaying] = useState(false)

  //Tutor variables
  const [botAudioData, setBotAudioData] = useState('')
  const [ttsData, setTtsData] = useState([])
  const [tutorialStart, setTutorialStart] = useState(false)
  const [isSubtitle, setIsSubtitle] = useState(true)
  const [isTutorPlayed, setIsTutorPlayed] = useState(false)
  const [ttsPlayType, setTtsPlayType] = useState('')
  const [feedbackType, setFeedbackType] = useState('')
  const [isAudioForcedStopped, setIsAudioForcedStopped] = useState(false)
  const [isAudioPlaying, setIsAudioPlaying] = useState(true)

  //Extra practice variables
  const [isExtraPracticeVisible, setIsExtraPracticeVisible] = useState(false)
  const [extraPracticeData, setExtraPracticeData] = useState({})

  const handleAudioURLChange = (newURL) => {
    setSavedAudioURL(newURL)
  }

  useEffect(() => {
    if (isBgAudioPlayed) {
      getActivityLoaded(false)
      updateActivityDataFromParent()
    } else {
      setCurrentPageNumber(-2)
    }
  }, [isBgAudioPlayed])

  useEffect(() => {
    if (isPreview) {
      if (isSequence) {
        setPriorityActive(1)
      } else {
        setPriorityActive(0)
      }
    }
  }, [isSequence])

  useEffect(() => {
    if (activityResetType) {
      if (
        activityDataFromParent.OtherActivities &&
        activityDataFromParent.OtherActivities !== null &&
        activityDataFromParent.OtherActivities.length > 0
      ) {
        let initialAllPagesData = []
        activityDataFromParent.OtherActivities.map((obj, index) => {
          initialAllPagesData[index] = {
            ContentID: obj.ContentID,
            Attempts: 0,
            Work: '',
            Ink: '',
            WorkJson: '',
            InkJson: '',
            Reset: 0,
            TotalTries: 1
          }
        })
        setAllPagesData(initialAllPagesData)
      }
      setPriorityActive(0)
      setIsPageNavigated(true)
      setStrokeReplayStarted(false)
      resetCall()
    }
  }, [activityResetType])

  function resetCall() {
    setSavedAudioURL(null)
    setDisplayComponents(false)
    setReplayRectangleStrokesData({
      ControlID: 0,
      BoxPosition: 0,
      strokeArray: [],
      strokeActions: []
    })
    setSketchPadDataArray([])
    setTextAreaData('')
    setIsSecModalActive(false)
    setCurrentScore(0)
    if (!isAudioPlaying) {
      setIsAudioForcedStopped(true)
      setTimeout(() => {
        setIsAudioForcedStopped(false)
      }, 500)
    }
    setTimeout(() => {
      setCurrentPageNumber(0)
    }, 1000)
  }

  function updateActivityDataFromParent() {
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      let initialAllPagesData = []
      activityDataFromParent.OtherActivities.map((obj, index) => {
        initialAllPagesData[index] = {
          ContentID: obj.ContentID,
          Attempts: 0,
          Work: obj.WorkJson ? obj.WorkJson : '',
          Ink: obj.InkJson ? obj.InkJson : '',
          WorkJson: obj.WorkJson ? obj.WorkJson : '',
          InkJson: obj.InkJson ? obj.InkJson : '',
          Reset: 0,
          TotalTries: 1
        }
      })
      setAllPagesData(initialAllPagesData)
      setTimeout(() => {
        setCurrentPageNumber(0)
      }, 1000)
    } else {
      setCurrentPageNumber(0)
    }
  }

  useEffect(() => {
    if (isBgAudioPlayed) {
      // getCurrentActivePage(currentPageNumber)
      if (currentPageNumber > -1) {
        setIsTutorPlayed(false)
        knovoHelpClose()
        if (
          activityDataFromParent.OtherActivities &&
          activityDataFromParent.OtherActivities !== null &&
          activityDataFromParent.OtherActivities.length > 0
        ) {
          setTimeout(() => {
            setCurrentActivity(
              activityDataFromParent.OtherActivities[currentPageNumber]
            )
          }, 1000)
        } else {
          setCurrentActivity(activityDataFromParent)
        }
      } else if (currentPageNumber === -1) {
        if (OtherActivities && OtherActivities.length > 0) {
          // setActivitySmartPaperData();
        } else {
          setCurrentActivity(activityDataFromParent)
        }
      }
    }
  }, [currentPageNumber])

  useEffect(() => {
    if (currentPageNumber > -1) {
      setSmartCanvasData({
        BackgroundImage: '',
        Strokes: [],
        StrokeActions: [],
        InputRows: [],
        ReplayRectangles: [],
        TotalScore: 0,
        EditorImageHeight: 0,
        EditorImageWidth: 0,
        ReplayRectanglesAudio: [],
        Opacity: 'rgba(0,0,0,0)',
        TextToSpeech: [],
        Seconds: [],
        Back: false,
        Skip: false,
        Stop: false,
        ChatBotSettings: ''
      })

      setTimeout(() => {
        setActivitySmartPaperData()
      }, 200)
    }
  }, [currentActivity])

  function setActivitySmartPaperData() {
    // clearCanvas();

    if (ActivityJson) {
      const exercise = JSON.parse(ActivityJson)
      console.log('exercise', exercise)
      if (AppName === 'SmartPaper') {
        setPriorityActive(0)
        findSkippableComponents(exercise.InputRows)
        setSmartCanvasData({
          BackgroundImage: exercise.BackgroundImage,
          InputRows: exercise.InputRows,
          ReplayRectangles: exercise.ReplayRectangles,
          StrokeActions: exercise.StrokeActions,
          Strokes: exercise.Strokes,
          TotalScore: exercise.TotalScore,
          EditorImageWidth: exercise.EditorImageWidth,
          EditorImageHeight: exercise.EditorImageHeight,
          ReplayRectanglesAudio: [],
          Opacity: exercise.Opacity,
          TextToSpeech: exercise.TextToSpeech,
          Seconds: exercise.Seconds,
          Back: exercise.Back,
          Skip: exercise.Skip,
          Stop: exercise.Stop,
          ChatBotSettings: exercise.ChatBotSettings
            ? exercise.ChatBotSettings
            : ''
        })
      }
    }
  }

  function findSkippableComponents(inputRows) {
    let skipComponentArray = {}
    if (inputRows && inputRows.length > 0) {
      for (const key in inputRows) {
        if (Object.prototype.hasOwnProperty.call(inputRows, key)) {
          //check skip or not
          if (
            inputRows[key].PluginId == 'SCTextArea' ||
            inputRows[key].PluginId == 'SCHotspotImages' ||
            inputRows[key].PluginId == 'SCEnrichedPDF'
          ) {
            skipComponentArray[inputRows[key].Priority] = true
          } else {
            if (inputRows[key].PluginId == 'SCRichText') {
              if (inputRows[key].Editable) {
                skipComponentArray[inputRows[key].Priority] = false
              } else {
                skipComponentArray[inputRows[key].Priority] = true
              }
            } else {
              skipComponentArray[inputRows[key].Priority] = false
            }
          }
        }
      }
      setSkipUnskipComponent(skipComponentArray)
    }
  }

  useEffect(() => {
    if (smartCanvasData.BackgroundImage !== '') {
      if (Completed === 0 && isActive) {
        checkTutorInstructions()
      } else {
        setTutorialStart(false)
        setIsTutorPlayed(true)
      }
    }
  }, [smartCanvasData])

  //check tutor message is available and play
  function checkTutorInstructions() {
    let botTtsData = getTutorAudio()
    if (botTtsData.tutorTtsAudio !== '') {
      setTtsPlayType(TUTOR_BOT)
      setBotAudioData(botTtsData.tutorTtsAudio)
      setTutorialStart(true)
    } else {
      setTutorialStart(false)
      setIsTutorPlayed(true)
    }
    if (botTtsData.tutorTtsText !== '') {
      setTtsData(botTtsData.tutorTtsText)
    }
  }

  //Get initial instructions data
  function getTutorAudio() {
    const exercise = JSON.parse(ActivityJson)
    let tutorBotData = {
      tutorTtsAudio: '',
      tutorTtsText: []
    }
    if (exercise.SpeechAudioData) {
      let activityInitialInstruction = exercise.SpeechAudioData
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsAudio = activityInitialInstruction.speechAudioLink
      }
      if (activityInitialInstruction.speechAudioLink) {
        tutorBotData.tutorTtsText = activityInitialInstruction.speechData
      }
    }
    return tutorBotData
  }

  useEffect(() => {
    if (isTutorPlayed) {
      isPageChanged.current = false
      setBotAudioData('')
      setWorkJsonData()
    }
  }, [isTutorPlayed])

  function setWorkJsonData() {
    let activityWorkJson = ''
    let currentInkJsonData = []
    if (currentPageNumber > -1) {
      if (allPagesData[currentPageNumber]) {
        let allPagesDataJson = allPagesData[currentPageNumber]
        if (allPagesDataJson.WorkJson) {
          activityWorkJson = allPagesDataJson.WorkJson
        }
        if (allPagesDataJson.InkJson) {
          currentInkJsonData = JSON.parse(allPagesDataJson.InkJson)
          let isArray = Array.isArray(currentInkJsonData)
          if (isArray) {
            setReplayRectangleStrokesData(currentInkJsonData[0])
          } else {
            setReplayRectangleStrokesData(currentInkJsonData)
          }
        }
      }
    }

    let condition =
      activityWorkJson !== '' &&
      JSON.parse(activityWorkJson).filter(
        (e) => e.ContentID === ContentID && e.ModeName === 'Paper'
      ).length > 0
    if (condition) {
      let indexOfPaper = JSON.parse(activityWorkJson).findIndex(
        (obj) => obj.ContentID === ContentID && obj.ModeName === 'Paper'
      )
      const workJson = JSON.parse(activityWorkJson)[indexOfPaper]
      setStudentWorkData(workJson)
      //load sketch pad data
      if (workJson.sketchPadData) {
        setSketchPadDataArray(workJson.sketchPadData)
      }
      //load saved text area data
      setTextAreaData(workJson.textAreaData ? workJson.textAreaData : '')
      //load saved recorded audio url
      setSavedAudioURL(workJson.RecordedUrl ? workJson.RecordedUrl : null)
      //load saved previously worked priority
      setPriorityActive(workJson.priorityCount ? workJson.priorityCount : 1)
      setIsWorkAvailable(true)
      setIsPageNavigated(false)
    } else {
      setDisplayComponents(true)
      setSavedAudioURL(null)
      loadReplayRectData()
      setPriorityActive(1)
      setIsPageNavigated(false)
    }
  }

  useEffect(() => {
    if (isWorkAvailable) {
      setDisplayComponents(true)
    }
  }, [isWorkAvailable])

  function loadReplayRectData() {
    let replayRectangleData = {}
    if (smartCanvasData.ReplayRectangles.length > 0) {
      let rectangleData = smartCanvasData.ReplayRectangles[0]
      replayRectangleData = {
        ControlID: rectangleData.ControlID,
        BoxPosition: rectangleData.BoxPosition,
        strokeArray: [],
        strokeActions: []
      }
    } else {
      replayRectangleData = {
        ControlID: 0,
        BoxPosition: 0,
        strokeArray: [],
        strokeActions: []
      }
    }

    setReplayRectangleStrokesData(replayRectangleData)
  }

  useEffect(() => {
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      getStudentCurrentScore(overallActivityScore)
    } else {
      getStudentCurrentScore(currentScore)
    }
  }, [currentScore, overallActivityScore])

  useEffect(() => {
    if (allPagesData.length > 0) {
      let overallActivityScoreCopy = 0
      allPagesData.map((pageData, pageIndex) => {
        if (
          pageData.WorkJson &&
          pageData.WorkJson !== '' &&
          JSON.parse(pageData.WorkJson).length > 0
        ) {
          const workJson = JSON.parse(pageData.WorkJson)[0]
          overallActivityScoreCopy = overallActivityScoreCopy + workJson.Score
        }
      })
      setOverallActivityScore(overallActivityScoreCopy)
    }
  }, [allPagesData])

  useEffect(() => {
    if (controlsList.length > 0) {
      handleCurrentPageStudentData(controlsList)
    }
  }, [controlsList])

  function handleCurrentPageStudentData(controlsListData) {
    if (controlsListData && controlsListData.length > 0) {
      let score = 0
      controlsListData.forEach((control) => {
        const item = smartCanvasData.InputRows.find(
          (row) => row.ControlID === control.CtlId
        )
        if (item && item.PluginId) {
          if (item.PluginId === 'AGTextList' || item.PluginId === 'AGInkList') {
            if (parseFloat(control.CtlValue.Value) > 0) {
              score += parseFloat(control.CtlValue.Value)
            }
          } else if (
            item.PluginId === 'MatchTable' ||
            item.PluginId === 'Fraction' ||
            item.PluginId === 'EquationEditor' ||
            item.PluginId === 'H5P'
          ) {
            score += control.CtlScore
          } else if (
            item.PluginId === 'PopupSlide' ||
            item.PluginId === 'SCRichText'
          ) {
            //score += parseFloat(control.CtlValue.Score);
          } else {
            if (item.Type === 'range') {
              if (item.CorrectAnswer === control.CtlValue.Answer) {
                score += item.Weight
              } else if (
                parseFloat(control.CtlValue.Answer) >= item.MinValue &&
                parseFloat(control.CtlValue.Answer) <= item.MaxValue
              ) {
                score += item.Weight
              } else {
              }
            } else {
              if (!item.CaseSensitive) {
                if (item.CorrectAnswer === control.CtlValue.Answer) {
                  score += item.Weight
                }
              } else {
                if (
                  item.CorrectAnswer.toLowerCase() ===
                  control.CtlValue.Answer.toLowerCase()
                ) {
                  score += item.Weight
                }
              }
            }
          }
        } else {
          score += control.CtlScore
        }
      })
      setCurrentScore(score)
      setIsPageNavigated(false)
    } else {
      setCurrentScore(0)
    }
  }

  useEffect(() => {
    if (isPageNavigated || Completed === 1 || !isActive) {
    } else {
      if (currentScore >= 0) {
        let modifiedPageData = handlePageData()
        setAllPagesData(modifiedPageData)
      }
    }
  }, [currentScore, isPageNavigated])

  function handleReplayAreaData(
    controlID,
    boxPosition,
    strokeData,
    strokeActions
  ) {
    let replayRectDataCopy = { ...replayRectangleStrokesData }
    replayRectDataCopy.ControlID = controlID
    replayRectDataCopy.BoxPosition = boxPosition
    replayRectDataCopy.strokeArray = strokeData
    replayRectDataCopy.strokeActions = strokeActions
    setReplayRectangleStrokesData(replayRectDataCopy)
    // if (smartCanvasData.ReplayRectangles.length > 0) {
    //   let indexOfRectangle = smartCanvasData.ReplayRectangles.findIndex(
    //     (obj) => obj.ControlID === controlID
    //   )
    //   if (indexOfRectangle > -1) {

    //   }
    // }
  }

  useEffect(() => {
    if (isPageNavigated || Completed === 1 || !isActive) {
    } else {
      let modifiedPageData = handlePageData()
      setAllPagesData(modifiedPageData)
    }
  }, [replayRectangleStrokesData, isPageNavigated])

  useEffect(() => {
    if (activitySaveClick) {
      if (!isAudioPlaying) {
        setIsAudioForcedStopped(true)
        setTimeout(() => {
          setIsAudioForcedStopped(false)
        }, 500)
      }
      const completed = activitySaveType === SAVE_MODE.SAVE ? 0 : 1
      const resetData = activitySaveType === SAVE_MODE.SAVE ? 0 : 0
      let allPagesDataCopy = handlePageData()
      let workDataToApi = {}
      let inkDataToApi = {}
      if (allPagesDataCopy.length > 0) {
        workDataToApi = allPagesDataCopy[0].WorkJson
        inkDataToApi = allPagesDataCopy[0].InkJson
      } else {
        workDataToApi = [workData]
        inkDataToApi = inkData
      }
      let studentDataToApiCopy = studentDataToApi(
        currentLessonUnitDistId,
        user,
        activityDataFromParent,
        completed,
        currentScore,
        0,
        workDataToApi,
        inkDataToApi,
        getTimeSpent(minutes, seconds, false),
        resetData,
        getSubmitDate(),
        0,
        1,
        allPagesDataCopy
      )
      console.log('studentDataToApiCopy', studentDataToApiCopy)
      getStudentWorkedDataFromChild(studentDataToApiCopy, false)
    }
  }, [activitySaveClick])

  //save current page data
  function handlePageData() {
    const completed = 0
    const resetData = 0
    let studentWorkData = saveCurrentPageDataInLocal(
      completed,
      ContentID,
      'Paper',
      currentScore,
      minutes,
      seconds,
      0,
      controlsList,
      priorityActive,
      replayRectangleStrokesData,
      resetData,
      sketchPadDataArray,
      textAreaData,
      savedAudioURL
    )
    let allPagesDataCopy = [...allPagesData]
    allPagesDataCopy[currentPageNumber] = studentWorkData
    return allPagesDataCopy
  }

  function actionsWhenPageNavigate() {
    setSavedAudioURL(null)
    setDisplayComponents(false)
    setReplayRectangleStrokesData({
      ControlID: 0,
      BoxPosition: 0,
      strokeArray: [],
      strokeActions: []
    })
    setSketchPadDataArray([])
    setTextAreaData('')
    setIsSecModalActive(false)
    setCurrentScore(0)
    if (!isAudioPlaying) {
      setIsAudioForcedStopped(true)
      setTimeout(() => {
        setIsAudioForcedStopped(false)
      }, 500)
    }
  }

  function handlePageNavigationData() {
    setIsPageNavigated(true)
    setStrokeReplayStarted(false)
    let modifiedPageData = handlePageData()
    setAllPagesData(modifiedPageData)
    actionsWhenPageNavigate()
  }

  function onNavigationClick(navigationType) {
    if (navigationType === 'next') {
      if (
        activityDataFromParent.OtherActivities &&
        activityDataFromParent.OtherActivities !== null
      ) {
        if (
          currentPageNumber <
          activityDataFromParent.OtherActivities.length - 1
        ) {
          // setBotAudioData('')
          isPageChanged.current = true
          setIsWorkAvailable(false)
          if (Completed === 0 && isActive) {
            handlePageNavigationData()
          }
          setTimeout(() => {
            pageScrollType.current = navigationType
            setCurrentPageNumber((currentPageNumber) => currentPageNumber + 1)
          }, 500)
        } else {
          // showOrHideToaster(true, "You're on the last page", 'warning')
        }
      }
    } else if (navigationType === 'previous') {
      if (
        activityDataFromParent.OtherActivities &&
        activityDataFromParent.OtherActivities !== null
      ) {
        if (currentPageNumber > 0) {
          // setBotAudioData('')
          isPageChanged.current = true
          setIsWorkAvailable(false)
          handlePageNavigationData()
          setTimeout(() => {
            pageScrollType.current = navigationType
            setCurrentPageNumber((currentPageNumber) => currentPageNumber - 1)
          }, 500)
        } else {
          //(true, "You're on the first page", 'warning')
        }
      }
    }
  }

  useEffect(() => {
    getFullscreen(isMinimize)
  }, [isMinimize])

  function handleEsc(event) {
    if (event.keyCode === 27) {
      setIsMinimize(true)
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleEsc)
    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [])

  function renderMaxMin() {
    return (
      <div
        className={
          isMinimize ? 'temp-fullscreen-min-cont' : 'temp-fullscreen-max-cont'
        }
      >
        <Button
          className='fullscreen-button'
          hasIconOnly
          iconDescription={isMinimize ? 'Full screen' : 'Exit full screen'}
          renderIcon={isMinimize ? Maximize : Minimize}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          onClick={() => {
            setIsMinimize((prev) => !prev)
          }}
        />
      </div>
    )
  }

  function renderPageNavigation() {
    let currentTemplate = currentPageNumber < 1 ? 1 : currentPageNumber + 1
    let totalTemplates = activityDataFromParent.OtherActivities.length
    return (
      <div className='fullscreen-nav-cont'>
        <Button
          className='temp-header-button temp-button1-style'
          hasIconOnly
          size='default'
          renderIcon={PreviousOutline}
          iconDescription='Previous page'
          tooltipAlignment='center'
          tooltipPosition='bottom'
          onClick={() => {
            onNavigationClick('previous')
          }}
        />

        <Button
          className='temp-header-button temp-button2-style'
          isExpressive={false}
          size='default'
        >
          {currentTemplate + ' / ' + totalTemplates}
        </Button>
        <Button
          className='temp-header-button temp-button1-style'
          hasIconOnly
          size='default'
          renderIcon={NextOutline}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          iconDescription='Next page'
          onClick={() => {
            onNavigationClick('next')
          }}
        />
      </div>
    )
  }

  useEffect(() => {
    setAiChatResponseData(updatedAIResponse)
  }, [updatedAIResponse])

  function renderAIChatBot() {
    return (
      <div>
        <AiAssistanceBot
          chatBotSettings={smartCanvasData.ChatBotSettings}
          aiChatResponse={aiChatResponseData}
          isKnovoApiCall={isKnovoApiCall}
          onAiDialogClose={(aiDialogClose) => {
            if (aiDialogClose) {
              setIsAiChatBotVisible(false)
              setAiChatResponseData({})
            }
          }}
          onClarificationClick={handleChatClarification}
          // onClarificationClick={(clarificationType, clarificationData) => {
          //   onClarificationClick(clarificationType, clarificationData)
          // }}
        />
      </div>
    )
  }

  useEffect(() => {
    if (isPreview) {
    } else {
      getRecordingStatus(isRecording)
    }
  }, [isRecording])

  function handleVideostatus(videoStatus) {
    setIsVideoPlaying(videoStatus)
  }

  useEffect(() => {
    if (priorityActive > 0) {
      const exercise = JSON.parse(ActivityJson)
      const currentLayoutID = exercise.TemplateSettings.layoutId
      if (isPreview) {
        if (currentLayoutID > 5) {
          handlePriorityChange(SEQUENCE_BOT)
        }
      } else {
        if (FollowTheFlow) {
          if (currentLayoutID > 5) {
            handlePriorityChange(SEQUENCE_BOT)
          }
        }
      }
    }
  }, [priorityActive])

  function handlePriorityChange(callType) {
    let currentComponentData = getCurrentComponentData()
    let componentSpeechData =
      getCurrentComponentSpeechData(currentComponentData)
    if (componentSpeechData.speechAudioLink === '') {
      if (currentComponentData.ReplaySpeed) {
        setPriorityActive((priorityActive) => priorityActive + 1)
      } else {
        if (
          currentComponentData.PluginId === 'SCTextArea' ||
          currentComponentData.PluginId === 'SCHotspotImages' ||
          currentComponentData.PluginId === 'SCRichText'
        ) {
          setPriorityActive((priorityActive) => priorityActive + 1)
        } else {
          setTtsPlayType(SEQUENCE_BOT)
          setBotAudioData(componentSpeechData.speechAudioLink)
          setTtsData(componentSpeechData.speechData)
        }
      }
    } else {
      if (currentComponentData.PluginId === 'SCRichText') {
        setPriorityActive((priorityActive) => priorityActive + 1)
      } else {
        setTtsPlayType(SEQUENCE_BOT)
        setBotAudioData(componentSpeechData.speechAudioLink)
        setTtsData(componentSpeechData.speechData)
        if (callType === SEQUENCE_BOT) {
          setTutorialStart(true)
        }
      }
    }
  }

  function getCurrentComponentData() {
    let currentPageData = getCurrentPageData()
    const { TemplateSettings, InputRows, ReplayRectangles } = currentPageData
    let indexOfCurrentControl = InputRows.findIndex(
      (obj) => obj.Priority === priorityActive
    )
    let currentComponentData = {}
    if (indexOfCurrentControl > -1) {
      currentComponentData = InputRows[indexOfCurrentControl]
    } else {
      let indexOfCurrentControlReplay = ReplayRectangles.findIndex(
        (obj) => obj.Priority === priorityActive
      )
      if (
        indexOfCurrentControlReplay >= 0 &&
        ReplayRectangles &&
        ReplayRectangles[indexOfCurrentControlReplay]
      ) {
        currentComponentData = ReplayRectangles[indexOfCurrentControlReplay]
        // setPriorityActive((priorityActive) => priorityActive + 1)
      } else {
        let multipleComponentsData = InputRows.filter(
          (e) => e.PluginName === 'Dropdown' || e.PluginName === 'InputAnswer'
        )
        if (multipleComponentsData && multipleComponentsData.length > 0) {
          let multipleComponentsDataArray = []
          multipleComponentsData.map((item) => {
            item.Options.map((values) => {
              multipleComponentsDataArray.push(values)
            })
          })
          let indexOfCurrentControlMultiple =
            multipleComponentsDataArray.findIndex(
              (obj) => obj.Priority === priorityActive
            )
          if (indexOfCurrentControlMultiple >= 0) {
            currentComponentData =
              multipleComponentsDataArray[indexOfCurrentControlMultiple]
          }
        }
      }
    }
    return currentComponentData
  }

  function getCurrentPageData() {
    let templateData = activityDataFromParent.OtherActivities[currentPageNumber]
    //get current template data
    const curretnActivityJson = JSON.parse(templateData.ActivityJson)
    return curretnActivityJson
  }

  function getCurrentComponentSpeechData(currentComponentData) {
    let componentSpeechData = {
      speechAudioLink: '',
      speechAudioTimeStamps: [],
      speechData: []
    }
    if (currentComponentData.SpeechAudioData) {
      componentSpeechData.speechAudioLink =
        currentComponentData.SpeechAudioData.speechAudioLink
      componentSpeechData.speechData =
        currentComponentData.SpeechAudioData.speechData
    }
    return componentSpeechData
  }

  function checkAndMoveNextComponent() {
    let currentComponentData = getCurrentComponentData()
    if (currentComponentData.ReplaySpeed) {
      setPriorityActive((priorityActive) => priorityActive + 1)
    } else {
      if (currentComponentData.PluginId === 'SCTextArea') {
        setPriorityActive((priorityActive) => priorityActive + 1)
      } else {
        if (currentComponentData.InputType === 'label') {
          setPriorityActive((priorityActive) => priorityActive + 1)
        }
        //Changes for hand written
        // if (currentComponentData.Data && currentComponentData.Data.length > 0) {
        //   setPriorityActive((priorityActive) => priorityActive + 1)
        // }
      }
    }
  }

  function setCurrentSequenceMessage() {
    handlePriorityChange(FEEDBACK_BOT)
  }

  function handleFeedbackMessage(feedbackType, feedbackMessage) {
    window.speechSynthesis.cancel()
    if (feedbackType) {
      setFeedbackType('success')
      if (
        feedbackMessage.successAudioLink &&
        feedbackMessage.successAudioLink !== ''
      ) {
        setTtsPlayType(FEEDBACK_BOT)
        setBotAudioData(feedbackMessage.successAudioLink)
        setTtsData(feedbackMessage.successFeedback)
        setTutorialStart(true)
      } else {
        setTutorialStart(false)
        setPriorityActive((priorityActive) => priorityActive + 1)
      }
    } else {
      setFeedbackType('failure')
      if (
        feedbackMessage.failureAudioLink &&
        feedbackMessage.failureAudioLink !== ''
      ) {
        setTtsPlayType(FEEDBACK_BOT)
        setBotAudioData(feedbackMessage.failureAudioLink)
        setTtsData(feedbackMessage.failureFeedback)
        setTutorialStart(true)
      } else {
        setTutorialStart(false)
      }
    }
  }

  function handleSelectionStatus(status) {
    if (status) {
    } else {
      if (isPreview) {
        setIsExtraPracticeVisible(true)
        console.log('smartCanvasData', smartCanvasData.InputRows)
        // let currentComponentData = getCurrentComponentData()
        let currentComponentData = smartCanvasData.InputRows[1]
        let extraPracticeDataCopy = currentComponentData.ExtraPracticeComponents
        setExtraPracticeData(extraPracticeDataCopy)
        console.log('currentComponentData', currentComponentData)
      }
    }
  }

  useEffect(() => {
    getExtraPracticeStatus(isExtraPracticeVisible)
  }, [isExtraPracticeVisible])

  function getCurrentThemeData() {
    let templateData = activityDataFromParent.OtherActivities[currentPageNumber]
    //get current template data
    const curretnActivityJson = JSON.parse(templateData.ActivityJson)
    const { TemplateSettings } = curretnActivityJson
    //find current template theme
    let propertiesIndex = ThemesProperties.findIndex(
      (obj) => obj.themeName === TemplateSettings.themeName
    )
    let currentThemePropertiesCopy = {}
    if (propertiesIndex > -1) {
      currentThemePropertiesCopy = ThemesProperties[propertiesIndex]
    } else {
      currentThemePropertiesCopy = ThemesProperties[0]
    }
    //find current theme is light/dark
    let currentThemeProperties = TemplateSettings.isLight
      ? currentThemePropertiesCopy.themeLight
      : currentThemePropertiesCopy.themeDark
    let currentThemeData = currentThemeProperties
    return currentThemeData
  }

  function renderSmartCanvasTemplates() {
    let templateData = activityDataFromParent.OtherActivities[currentPageNumber]
    //get current template data
    const curretnActivityJson = JSON.parse(templateData.ActivityJson)
    let currentInkData = {}
    if (
      allPagesData[currentPageNumber].InkJson &&
      allPagesData[currentPageNumber].InkJson !== ''
    ) {
      currentInkData = JSON.parse(allPagesData[currentPageNumber].InkJson)
    }
    const { TemplateSettings, InputRows, ReplayRectangles } =
      curretnActivityJson
    //find current template theme
    let propertiesIndex = ThemesProperties.findIndex(
      (obj) => obj.themeName === TemplateSettings.themeName
    )
    let currentThemePropertiesCopy = {}
    if (propertiesIndex > -1) {
      currentThemePropertiesCopy = ThemesProperties[propertiesIndex]
    } else {
      currentThemePropertiesCopy = ThemesProperties[0]
    }
    //find current theme is light/dark
    let currentThemeProperties = TemplateSettings.isLight
      ? currentThemePropertiesCopy.themeLight
      : currentThemePropertiesCopy.themeDark
    let currentThemeData = currentThemeProperties
    return (
      <div
        key={'tempKey' + currentPageNumber}
        id={'template' + currentPageNumber}
        className={
          pageScrollType.current === 'next'
            ? 'template-container scroll-next'
            : 'template-container scroll-prev'
        }
        // style={{ pointerEvents: isPageChanged.current ? 'none' : 'auto' }}
      >
        <SmartCanvasTemplates
          smartPaperData={curretnActivityJson}
          isPractice={
            isPreview ? (isClassroom ? isPractice : true) : isPractice
          }
          Completed={isPreview ? (isClassroom ? Completed : 0) : Completed}
          isActive={isPreview ? (isClassroom ? false : true) : isActive}
          TemplateSettings={TemplateSettings}
          currentThemeData={currentThemeData}
          InputRows={InputRows}
          ReplayRectangles={ReplayRectangles}
          minutes={minutes}
          seconds={seconds}
          isFollowTheFlow={
            TemplateSettings.layoutId > 5
              ? isPreview
                ? isSequence
                : FollowTheFlow
              : false
          }
          // isFollowTheFlow={false}
          strokeColor={strokeColor}
          sketchType={sketchType}
          strokeWidth={strokeWidth}
          currentSpeed={currentSpeed}
          InkJson={currentInkData}
          strokeReplayStarted={strokeReplayStarted}
          displayComponents={displayComponents}
          isWorkAvailable={isWorkAvailable}
          studentWorkData={studentWorkData}
          isAudioPlaying={!isAudioPlaying}
          handleControlsList={(controlsList) => {
            setControlsList(controlsList)
          }}
          getCurrentRectangleData={(
            controlID,
            boxPosition,
            strokeData,
            strokeActions
          ) => {
            handleReplayAreaData(
              controlID,
              boxPosition,
              strokeData,
              strokeActions
            )
          }}
          getReplyStatus={(replayStatus) => {
            setIsReplaying(replayStatus)
            getStrokeReplaying(replayStatus)
          }}
          isReplaying={isReplaying}
          // getTutorTalking={getTutorTalking}
          getStrokeReplayFinished={() => {
            setStrokeReplayStarted(false)
          }}
          onWorkFetched={() => {
            setIsWorkAvailable(false)
          }}
          onToastTrigger={onToastTrigger}
          skipUnskipComponent={skipUnskipComponent}
          onVideoControlChange={handleVideostatus}
          priorityActive={priorityActive}
          onPriorityChange={(priorityValue) => {
            setPriorityActive((priorityActive) => priorityActive + 1)
          }}
          handleFeedbackMessage={handleFeedbackMessage}
          isMinimize={isMinimize}
          isPageChanged={isPageChanged.current}
          handleSelectionStatus={handleSelectionStatus}
        />
      </div>
    )
  }

  return (
    <div className='canvas-main-container'>
      {/* {isMinimize && ( */}
      <div
        className='canvas-header-container'
        style={{
          pointerEvents:
            isVideoPlaying ||
            isPageChanged.current ||
            isReplaying ||
            !isAudioPlaying
              ? 'none'
              : 'auto'
        }}
      >
        {isBgAudioPlayed && (
          <CanvasHeader
            isPreview={isPreview}
            smartCanvasData={smartCanvasData}
            totalTemplates={activityDataFromParent.OtherActivities.length}
            currentTemplate={currentPageNumber < 1 ? 1 : currentPageNumber + 1}
            savedAudioURL={savedAudioURL}
            strokeReplayStarted={strokeReplayStarted}
            onNavigationClick={(navigationType) => {
              onNavigationClick(navigationType)
            }}
            onModalItemClick={(modalName) => {
              if (
                modalName === COLOR_PALETTE ||
                modalName === PREVIOUS_WORK ||
                modalName === QUESTION
              ) {
              } else if (modalName === REPLAY) {
                setStrokeReplayStarted(true)
                setIsSecModalActive(false)
              } else if (modalName === SKETCH_PAD) {
                setIsSecModalActive((isSecModalActive) => !isSecModalActive)
                setSketchPadInitial(true)
                setStrokeReplayStarted(false)
              } else if (modalName === TEXT_AREA) {
                setIsSecModalActive((isSecModalActive) => !isSecModalActive)
                setSketchPadInitial(true)
                setStrokeReplayStarted(false)
              } else if (modalName === CHAT_BOT) {
                setIsSecModalActive(false)
                setIsAiChatBotVisible(true)
                setStrokeReplayStarted(false)
              } else if (modalName === '') {
                setIsSecModalActive(false)
                setStrokeReplayStarted(false)
              }
              setSecModalActiveName(modalName)
            }}
            onPaletteChange={(paletteValue) => {
              if (paletteValue) {
                setStrokeReplayStarted(false)
              }
              setIsPalleteOpen(paletteValue)
            }}
            handleAudioURLChange={handleAudioURLChange}
            getCurrentSpeed={(currentSpeed) => {
              setcurrentSpeed(currentSpeed)
            }}
            getRecordingStatus={(recordingStatus) => {
              setIsRecording(recordingStatus)
            }}
            onToastTrigger={onToastTrigger}
            isReplayAvailable={
              smartCanvasData.ReplayRectangles.length > 0 ? true : false
            }
            isSecModalActive={isSecModalActive}
            Completed={Completed}
            isActive={isActive}
            isAudioPlaying={!isAudioPlaying}
            isPageNavigated={isPageNavigated}
          />
        )}
      </div>
      {/* )} */}
      <div
        className='canvas-temp-container'
        style={{
          height: '92%',
          pointerEvents:
            isVideoPlaying ||
            isPageChanged.current ||
            isReplaying ||
            isRecording ||
            !isAudioPlaying
              ? 'none'
              : 'auto',
          position: isExtraPracticeVisible ? 'unset' : 'relative'
        }}
      >
        {isBgAudioPlayed && !isActivitySideMenuOpen && (
          <TemplatesList
            currentSelectedPage={currentPageNumber}
            activityDataFromParent={activityDataFromParent}
            controlsList={controlsList}
            isAudioPlaying={!isAudioPlaying}
            onTempSideMenuChange={(sideMenuStatus) => {
              setIsSideMenuOpen(sideMenuStatus)
            }}
            templateItemClick={(selectedIndex) => {
              if (isAudioPlaying) {
                // setBotAudioData('')
                isPageChanged.current = true
                handlePageNavigationData()
                setTimeout(() => {
                  let navigationType = 'next'
                  if (selectedIndex < currentPageNumber) {
                    navigationType = 'previous'
                  } else {
                    navigationType === 'next'
                  }
                  setTimeout(() => {
                    pageScrollType.current = navigationType
                    setCurrentPageNumber(selectedIndex)
                  }, 500)
                }, 500)
              }
            }}
          />
        )}
        {/* <HeaderModal /> */}
        {isSecModalActive && (
          <HeaderModal
            secModalActiveName={secModalActiveName}
            sketchPadInitial={sketchPadInitial}
            sketchPadDataArray={sketchPadDataArray}
            textAreaData={textAreaData}
            completed={Completed}
            isActive={isActive}
            onCloseClick={() => {
              setIsSecModalActive(false)
            }}
            onSketchDataCapture={(sketchPadData) => {
              setSketchPadDataArray(sketchPadData)
            }}
            onSketchDisplayed={() => {
              setSketchPadInitial(false)
            }}
            onTextAreaDataCapture={(textAreaData) => {
              setTextAreaData(textAreaData)
            }}
          />
        )}
        {isExtraPracticeVisible && (
          <ExtraPracticeModal
            extraPracticeData={extraPracticeData}
            themeProperties={getCurrentThemeData()}
            onCloseClick={() => {
              setIsExtraPracticeVisible(false)
            }}
            getTutorTalking={getTutorTalking}
          />
        )}
        {/* {secModalActiveName === 'colorPalette' && isMinimize && ( */}
        {isPalleteOpen && (
          <KnovaPalette
            isMinimize={isMinimize}
            getStrokeColor={(strokeColor) => {
              setStrokeColor(strokeColor)
            }}
            getStrokeType={(strokeType) => {
              if (strokeType === SELECT) {
                onToastTrigger('Draw a rectangle to select and delete strokes.')
              }
              setSketchType(strokeType)
            }}
            getStrokeWidth={(strokeWidth) => {
              setStrokeWidth(strokeWidth)
            }}
          />
        )}
        <div
          id='container'
          className='temp-list-container'
          style={{
            filter: displayComponents ? 'unset' : 'blur(3px)',
            padding: !isMinimize ? 'unset' : '1% 7%',
            pointerEvents: isRecording ? 'none' : 'auto'
          }}
        >
          {currentPageNumber > -1 &&
            allPagesData.length > 0 &&
            renderSmartCanvasTemplates()}

          {displayComponents && !isPreview && renderMaxMin()}
          {/* {!isMinimize && renderPageNavigation()} */}
        </div>
        {/* {isKnovoHelpOpen && (
        <KnovoHelp
          onBotAnimeClose={() => {
            knovoHelpClose();
          }}
          onKnovoHelpSelected={(helpSelected, isShowAnswer) => {
            if (helpSelected === "tips") {
              if (
                FollowTheFlow &&
                !isRecording &&
                !isRecordPlaying &&
                !isReplayHappening &&
                !botTalking
              ) {
                knovoHelpClose();
                setShowHint(false);
                window.speechSynthesis.cancel();
                if (Completed === 0) {
                  if (isPractice && hintMessage && hintMessage !== "") {
                    setAudioStop(true);
                    setTtsPlayType("hint");
                    setTtsMessageData(hintMessage);
                    setTtsPlayStart(true);
                  }
                }
              }
            } else if (helpSelected === "instruction") {
              knovoHelpClose();
            } else if (helpSelected === "walkthrough") {
              knovoHelpClose();
              knovoActivityTourClick();
            } else if (helpSelected === "alChatBot") {
              knovoHelpClose();
              setIsAiChatBotVisible(true);
            } else {
              if (isPractice || Completed === 1 || !isActive) {
                if (isShowAnswer) {
                  setcurrentDisplayMode("verify");
                } else {
                  setcurrentDisplayMode("normal");
                }
              }
            }
          }}
          onHelpNeeded={(helptype) => {
            if (helptype === "contained") {
              let selectedContained = ContainedView[0].ContentID;
              getContainedActivityForStudent(
                user.LoginID,
                selectedContained,
                (response) => {
                  currentAppName.current = response.AppName;
                  setisPopupSlideVisible(true);
                }
              );
            } else {
              setIsNeedClick(true);
              let popupExteValue = {
                MarkerName: "PEMDAS TUTORIAL",
                MarkerValue: "https://youtu.be/x41BCrYh8Kc",
              };
              currentPopupValue.current = popupExteValue;
              setExternalPopupVisible(true);
            }
          }}
          isGuidedActivity={isGuidedActivity}
          guidedData={guidedData}
          onGuidedClick={(guideType) => {
            let isClickable = false;
            if (FollowTheFlow) {
              if (skipUnskipComponent[priorityActive]) {
                setIsGuidedClickEnable(true);
                isClickable = true;
                // setIsGuidedClickEnable(false);
              } else {
                let indexOfPaper = smartPaperData.ReplayRectangles.findIndex(
                  (obj) => obj.Priority === priorityActive
                );
                if (indexOfPaper < 0) {
                  setIsGuidedClickEnable(true);
                  isClickable = true;
                } else {
                  setIsGuidedClickEnable(false);
                }
              }
              if (isClickable) {
                if (guideType === "guided") {
                  setIsGuidedClicked(true);
                  if (
                    props.currentActivity.ContainedView &&
                    props.currentActivity.ContainedView.length > 0
                  ) {
                    const markerContent =
                      props.currentActivity.ContainedView.find(
                        ({ SlideID }) => {
                          return SlideID === guidedData.MarkerValue;
                        }
                      );
                    let selectedContained = markerContent.ContentID;
                    getContainedActivityForStudent(
                      user.LoginID,
                      selectedContained,
                      (response) => {
                        currentAppName.current = response.AppName;
                        setisPopupSlideVisible(true);
                      }
                    );
                  }
                }
              } else {
                setIsGuidedClicked(false);
                showOrHideToaster(
                  true,
                  "Guided tutoring is not available for this component",
                  "warning"
                );
              }
            } else {

            }
          }}
          isPractice={isPractice}
        />
      )} */}
      </div>
      {displayComponents && isAiChatBotVisible && renderAIChatBot()}
      {isBgAudioPlayed && botAudioData !== '' && !isExtraPracticeVisible && (
        <BotAssistSettings
          audioUrl={botAudioData}
          text={ttsData}
          tutorialStart={tutorialStart}
          botType={ttsPlayType}
          getTutorTalking={(audioStatus) => {
            setIsAudioPlaying(audioStatus)
            getTutorTalking(audioStatus)
          }}
          isAudioForcedStopped={isAudioForcedStopped}
          isMinimize={isMinimize}
          onBotComplete={() => {
            setTutorialStart(false)
            setIsTutorPlayed(true)
            if (ttsPlayType === SEQUENCE_BOT) {
              checkAndMoveNextComponent()
            } else if (ttsPlayType === FEEDBACK_BOT) {
              if (feedbackType === 'success') {
                setPriorityActive((priorityActive) => priorityActive + 1)
              } else {
                // if (failureExternalText !== "") {
                //   setFailurePopupVisible(true);
                // }
                if (isPreview) {
                  setIsExtraPracticeVisible(true)
                  let currentComponentData = getCurrentComponentData()
                  console.log('currentComponentData', currentComponentData)
                } else {
                  setCurrentSequenceMessage()
                }
              }
            }
          }}
          onBotStopped={() => {
            setTutorialStart(false)
          }}
          onFrwdSkipClick={() => {
            if (ttsPlayType === TUTOR_BOT) {
              setTutorialStart(false)
              setIsTutorPlayed(true)
            } else if (ttsPlayType === SEQUENCE_BOT) {
              if (priorityActive >= Object.keys(skipUnskipComponent).length) {
                // onSkipError(true)
                // if (status) {
                //   showOrHideToaster(
                //     true,
                //     "You are done with this activity. Press the button above to move to another activity.",
                //     "warning"
                //   );
                // } else {
                //   showOrHideToaster(
                //     true,
                //     "You cannot skip this section",
                //     "warning"
                //   );
                // }
              } else {
                if (skipUnskipComponent[priorityActive]) {
                  if (!isAudioPlaying) {
                    setIsAudioForcedStopped(true)
                    setTimeout(() => {
                      setIsAudioForcedStopped(false)
                    }, 500)
                    setTutorialStart(false)
                    setPriorityActive((priorityActive) => priorityActive + 1)
                  }
                  // if (isDelayRunning) {
                  //   onSkipWhenNotPlaying()
                  // } else {
                  //   isForceStop.current = true
                  //   isSeqPause.current = false
                  //   stopTtsPlaying()
                  // }
                } else {
                  // onSkipError(false)
                  // if (status) {
                  //   showOrHideToaster(
                  //     true,
                  //     "You are done with this activity. Press the button above to move to another activity.",
                  //     "warning"
                  //   );
                  // } else {
                  //   showOrHideToaster(
                  //     true,
                  //     "You cannot skip this section",
                  //     "warning"
                  //   );
                  // }
                }
              }
            }
          }}
        />
      )}
    </div>
  )
}
export { SmartCanvasBaseScreen }
